import { render, staticRenderFns } from "./StorageBaseAbstract.vue?vue&type=template&id=ce6c9766&"
import script from "./StorageBaseAbstract.vue?vue&type=script&lang=js&"
export * from "./StorageBaseAbstract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports